"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicFormConfigEntityType = void 0;
/**
 * This enum is the same as the one in the API.
 * It is duplicated here to avoid build errors in management.
 */
var DynamicFormConfigEntityType;
(function (DynamicFormConfigEntityType) {
    DynamicFormConfigEntityType["DRIVER"] = "DRIVER";
    DynamicFormConfigEntityType["DRIVER_COMPANY"] = "DRIVER_COMPANY";
})(DynamicFormConfigEntityType || (exports.DynamicFormConfigEntityType = DynamicFormConfigEntityType = {}));
//# sourceMappingURL=DynamicFormConfigEntityType.js.map